import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { FilterControlParams } from '../../../interfaces/filter-control-params';

@Component({
  selector: 'bm-time-filter',
  templateUrl: './time-filter.component.html',
  styleUrls: ['./time-filter.component.scss']
})
export class TimeFilterComponent implements OnInit {

  @HostBinding('class')
  @Input() className = '';

  @Input() control: FilterControlParams;

  constructor() {}

  ngOnInit() {}

}
